import { Module } from 'vuex'
import { ICouponsState, IRootState } from '@/@types'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const coupons: Module<ICouponsState, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default coupons
